export const selectGetProductsList = (state) => state.products?.productsList;
